const autoLoginKey = 'auto_login_attempt'
const autoLoginTtlMs = 50000

export type AutoLoginError = {
  provider?: string
  message: string
  status: string
  timestamp: number
}

export function markAutoLoginAttempt() {
  sessionStorage.setItem(
    autoLoginKey,
    JSON.stringify({
      timestamp: Date.now(),
    })
  )
}

export function setLoginError(message: string, status: string, provider?: string) {
  sessionStorage.setItem(
    autoLoginKey,
    JSON.stringify({
      timestamp: Date.now(),
      error: {
        provider,
        message,
        status,
        timestamp: Date.now(),
      } satisfies AutoLoginError,
    })
  )
}

export function canAutoLogin(): boolean {
  const raw = sessionStorage.getItem(autoLoginKey)
  if (!raw) return true

  try {
    const { timestamp } = JSON.parse(raw)
    if (typeof timestamp !== 'number') return true

    return Date.now() - timestamp > autoLoginTtlMs
  } catch {
    return true
  }
}

export function getAutoLoginError(): AutoLoginError | null {
  const raw = sessionStorage.getItem(autoLoginKey)
  if (!raw) return null

  try {
    const { error, timestamp } = JSON.parse(raw)
    if (!error || typeof timestamp !== 'number') return null

    if (Date.now() - timestamp > autoLoginTtlMs) {
      clearAutoLoginAttempt()
      return null
    }

    return error
  } catch {
    return null
  }
}

export function clearAutoLoginAttempt() {
  sessionStorage.removeItem(autoLoginKey)
}
